/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `:host {
  display: block;
  box-sizing: border-box;
  contain: content;
  font-size: 1rem;
  padding: 1rem 1.5rem 1.5rem;
}

:host([hidden]) {
  display: none;
}

#holder {
  width: 100%;
  height: 100%;
}

:host {
  height: 10rem;
  min-height: 10rem;
}
:host .inner {
  display: flex;
  flex-direction: row;
  height: 100%;
}`;
export { style };
